import React, { Component } from "react";
import ArticleCard from "./Articles/ArticleCard";
import ComingSoon from "./Articles/ComingSoon";
import { CardDeck } from 'reactstrap';
import AdChitika from "./Ads/AdChitika";


class Home extends Component {

  render() {

    var homeStyle = {
      paddingTop: "65px"
    };

    var cardDeckStyle = {
        backgroundColor: "black",
        borderBottomStyle: "solid",
        borderTopStyle: "solid",
        borderColor: "darkslategray",
        padding: 10
    }

    var comingSoonStyle = {
       paddingTop: 30,
       paddingBottom: 30
    }

    var adStyle={
      justifyContent: "center"
    }

    return (
      <div className="Site-content" style={homeStyle} >
      <div className="container">
      <div style={adStyle} className="row">
      <AdChitika publisher="Gaztingo" />
      </div>
      </div>
      <div className="container-fluid">
        <CardDeck id="articles" className="d-flex justify-content-center" style={cardDeckStyle}>
          <ArticleCard page={"home"} />
        </CardDeck>

        <CardDeck style={comingSoonStyle} id="comingSoon" className="d-flex justify-content-center" >
            <ComingSoon />
        </CardDeck>
      </div>
      </div>

    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js